import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

window.addEventListener("beforeunload", (event) => {
  if (event.clientX < 0 && event.clientY < 0) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  }
});

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/components/Login.vue"),
    meta: { hideLayout: true, requiresAuth: false },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("@/components/Dashboard.vue"),
    meta: { hideLayout: true, requiresAuth: false },
  },
  {
    path: "/",
    name: "Login",
    component: () => import("@/components/Login.vue"),
    meta: { hideLayout: true, requiresAuth: false },
  },
  {
    path: "/forgetpassword",
    name: "ForgetPassword",
    component: () => import("@/components/resetPassword.vue"),
    meta: { hideLayout: true, requiresAuth: false },
  },
  {
    path: "/agencycoverage",
    name: "AgencyCoverage",
    component: () => import("@/components/AgencyCoverage.vue"),
    meta: { hideLayout: true, requiresAuth: false },
  },


  // {
  //   path: "/dashboard",
  //   name: "home",
  //   component: HomeView,
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
